import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Backdrop, Button, CircularProgress, Container, Typography, Box } from "@mui/material";
import SumupPayWidget from '../components/ui/SumupPayWidget';
import { Context } from "../App";
import {v4 as uuid} from 'uuid';
import BilletInfoSection from "../components/sections/BilletInfoSection";
import DonInfoSection from "../components/sections/DonInfoSection";
import { Link, useNavigate } from "react-router-dom";

export default function Panier(){
    const navigate = useNavigate()
    const { userId, setUserId, isConnected, setIsConnected, deconnect } = React.useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [panier, setPanier] = React.useState()
    const [checkoutId, setCheckoutId] = React.useState(null);

    function getItemTotal(item) {
        if(item.collectionName === 'Don') {
            const don = item.id;
            const total =  (don.dime||0)+(don.offrande_globale||0) + 
            [...don.offrande_spe_feam, ...don.offrande_spe_eglise, ...don.projets].reduce((acc, curr) => acc + curr.montant, 0)  
            return total;
        } else {
            return item.id.price;
        }
    }
    const total = React.useMemo(() => panier?.items.reduce((acc, item) => acc + (getItemTotal(item) * (item.quantity||1)), 0), [panier]);

    React.useEffect(()=>{
        let token = localStorage.getItem('token');
        if (!token || !isConnected) {
            let userId = localStorage.getItem('anonUserId');
            if (!userId) {
                userId = uuid();
                localStorage.setItem('anonUserId', userId);
            }
            setUserId(userId); token = userId;
        }

        setLoad(true);
        fetch(process.env.REACT_APP_ESDRAS_API_URL.concat('/panier/by/owner'), {method: 'GET', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(async(res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(res.status === 401) {
                deconnect();
            }
            if(!res.ok) {
                const error = await res.text();
                throw new Error(`API error: ${res.status} - ${error}`);
            }
            const data = await res.json();
            setPanier(data);
            setLoad(false);
        }).catch((err) => {
            console.error("Error fetching panier:", err);
            setLoad(false);
        }).finally(() => setLoad(false));
    }, [userId])

    function CreatePaiement() {
        setLoad(true)
        const query = new URLSearchParams({panier: panier._id}).toString();
        fetch(`${process.env.REACT_APP_ESDRAS_API_URL}/stripe/checkout?${query}`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(res.status === 401) {
                deconnect();
            }
            if (!res.ok) {
                throw new Error('Failed to create Stripe session '+res.statusText);
            }
            return res.json();
        })
        .then(data => {
            window.location.href = data.url; // redirection vers Stripe
        }).catch((err) => {
            console.error("Error during payment:", err);
            setLoad(false);
        });
    }

    function handleValide() { console.log("Handle valide called ", panier);
        // Recalculer le total directement pour éviter les problèmes de timing
        const currentTotal = panier?.items.reduce((acc, item) => acc + (getItemTotal(item) * (item.quantity||1)), 0) || 0;
        console.log("Validating panier with total:", currentTotal);
        if (currentTotal > 0) {
            CreatePaiement();
        } else {
            setLoad(true)
            const query = new URLSearchParams({_id: panier._id}).toString();
            fetch(`${process.env.REACT_APP_API_URL}/panier/free/validate?${query}`, {
                method: 'PATCH',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then(async(res) => {
                const token = res.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if(res.status === 401) {
                    deconnect(); setLoad(false); return;
                }
                if (!res.ok) {
                    const msg = await res.text();
                    if (msg) alert(msg);
                    throw new Error('Failed to validate panier '+res.statusText);
                }
                return res.json();
            }).then(data => {
                setLoad(false);
                navigate('/mes_billets');
            }).catch((err) => {
                console.error("Error validating panier:", err);
                setLoad(false);
            });
        }
    }

    function handleViderPanier() {
        setLoad(true)
        const query = new URLSearchParams({_id: panier._id}).toString();
        fetch(process.env.REACT_APP_ESDRAS_API_URL.concat('/panier/clear?'+query), {method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || userId}`
            }
        }).then(async(res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(!res.ok) {
                const error = await res.text();
                throw new Error(`API error: ${res.status} - ${error}`);
            }
            setPanier(old=> ({...old, items: []}))
            setLoad(false);
        }).catch((err) => {
            console.error("Error clearing panier:", err);
            setLoad(false);
        });
    }
    
    return(
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Container maxWidth="sm" sx={{ my: 4, minWidth: { xs: 'auto', sm: '500px' }, display:'flex', flexDirection:'column', px: { xs: 2, sm: 3 } }}>
                <Typography variant="h1" sx={{ fontSize: { xs: '2rem', sm: '2.5rem' } }}>Mon panier</Typography>

                {panier?.items.length <= 0 &&
                    <Typography variant="subtitle1" sx={{my:2, fontSize: { xs: '0.9rem', sm: '1rem' }}}>
                        <span style={{fontWeight:'bold', fontSize:18}}>Votre panier est vide.</span><br/><br/>Vous pouvez ajouter des articles à votre panier depuis les pages de don, soutien aux institution, projets ou billetterie.
                    </Typography>
                }

                {panier?.items.filter(i => i.collectionName==='Don').length > 0 &&
                    <Typography variant="h2" sx={{mt:2, mb:1, fontSize: { xs: '1.5rem', sm: '2rem' }}}>Dons</Typography>
                }

                {panier?.items.filter(i => i.collectionName==='Don').map((item, index) => 
                    <DonInfoSection key={index} index={index} don={item.id} setLoad={setLoad} setPanier={setPanier} rmDon={()=>setPanier(old=> ({...old, items: old.items.filter(i => i.id._id !== item.id._id)}))} updateDon={()=>setPanier(old=> ({...old, items: old.items.map(i => i.id._id === item.id._id ? {...i, id: item.id} : i)}))} />
                )}
                {panier?.items.filter(i => i.collectionName==='Billet').map((item, index) =>
                    <BilletInfoSection key={index} billet={item.id} setLoad={setLoad} setPanier={setPanier} rmBillet={()=>setPanier(old=> ({...old, items: old.items.filter(i => i.id._id !== item.id._id)}))} />
                )}

                {total>0 && <Typography variant="h2" sx={{mt:2, mb:1, fontSize: { xs: '1.5rem', sm: '2rem' }}}>
                    Total : <span style={{color:'var(--mui-palette-primary-main)'}}>{total.toFixed(2)} €</span>
                </Typography>}
                
                {!isConnected && <Typography variant="subtitle1" sx={{my:2, fontStyle:'italic', color:'alerte.main', fontSize: { xs: '0.875rem', sm: '1rem' }}}>
                    Vous devez être connecté pour valider votre panier. Connectez-vous ou créez un compte <Link to="/connexion" color="focus2" >ici</Link>.
                </Typography>}

                {!!panier && panier.items.length > 0 && <Button variant="outlined" color="validation.main" size="large" onClick={handleValide} disabled={panier.items.length<=0||!isConnected || panier.items.filter(i => i.collectionName==='Billet').some(el=> !!!el.id.owner?.nom || !!!el.id.owner?.prenom)} sx={{alignSelf:'center', px: { xs: 3, sm: 5 }, mb:2, borderWidth:3, py: { xs: 1, sm: 1.5 }, fontSize: { xs: '0.9rem', sm: '1rem' }}} >
                    Valider mon panier
                </Button>}

                <Typography variant="subtitle1" sx={{my:2, color:'primary', textAlign:'right', fontWeight:'bold', cursor:'pointer', fontSize: { xs: '0.875rem', sm: '1rem' }}} onClick={handleViderPanier}>
                    Vider le panier
                </Typography>
                
                <SumupPayWidget {...{checkoutId, total, handleResponse:()=>{setLoad(true); setTimeout(() => {
                    navigate('/paiement/status/' + checkoutId);
                }, 3500);}}} />
            </Container>
            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Footer />
        </Box>
    )
} 